export enum MerchantVerificationCheckEnum {
    IsTheAddressCorrect = 1,
    IsThePhotoClearAndAccurate = 2,
    LoremIpsumDolor = 3,
    BlurryImage = 4,
    IsNameMatchToTheLabelOfTheProduct = 5
}
